<!--
  * Contact Page
  * Contains the contact form
  *
  * Copyright (c) 2020-2021 Dev Null Productions - All Rights Reserved
  -->
<template>
  <MainLayout section="contact">
    <b-card bg-variant="info" text-variant="white" id="contact">
      <h2>Contact Us</h2>

      <h4>
        Have questions or feedback? Need technical support?
      </h4>

      <h4>You've come to the right place!</h4>

      <ContactForm />
    </b-card>
  </MainLayout>
</template>

<script>
import MainLayout  from './components/MainLayout'
import ContactForm from './components/forms/Contact'

export default {
  name: 'Contact',

  components: {
    MainLayout,
    ContactForm
  }
}
</script>

<style scoped>
#contact{
  margin: 50px auto;
  width: 50%;
}

#main_layout.sm #contact,
#main_layout.xs #contact{
  margin: unset;
  width: unset;
  padding-top: 25px;
}
#contact h2,
#contact h4{
  text-align: center;
  margin-bottom: 15px;
}
</style>
